import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventPropertyDownloadPlanRegister = () => {
    hitGoogleTagManager({
        event: "GAEvent",
        GAEventCategory: "ui",
        GAEventAction: "rejestracja",
        GAEventLabel: "download_plan",
        GAEventNoInteraction: true
    });
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventPropertyDownloadPlanRegister = () => {
    hitGoogleTagManager({
        event: "GAEvent",
        GAEventCategory: "ui",
        GAEventAction: "rejestracja",
        GAEventLabel: "download_plan",
        GAEventNoInteraction: true
    });
};
